export const AppConfig = {
    HIDDEN_MENU_COUNT: 1,
    HIDDEN_MENU_COUNT_STEP: 1000,
    HIDDEN_MENU_COUNT_THERESHOLD: 500,
    PROMOTION_WARNING_SEC: 5000,
    POINT_COLLECT_DOB_YEAR_START: 1930,
    POINT_COLLECT_DOB_YEAR_END: 2025,
    POINT_COLLECT_DOB_YEAR_DEFAULT: 2000,
    POINT_COLLECT_GENDER_DEFAULT: 'M',
    /** Banner popup on /home: give up on the banner request after this long. */
    BANNER_FETCH_TIMEOUT_MS: 6000,
    /** Banner popup on /home: the first slide must be decoded within this, or no popup this visit. */
    BANNER_FIRST_SLIDE_TIMEOUT_MS: 8000,
    /** Banner popup carousel auto-advance interval. */
    BANNER_SLIDE_INTERVAL_MS: 5000,
    /** Horizontal finger travel that counts as a swipe in the banner carousel. */
    BANNER_SWIPE_THRESHOLD_PX: 50,
    /** Staff PIN: exactly this many digits, checked once when the last one is typed. */
    STAFF_PIN_LENGTH: 6,
    /** Approval request stream: wait before reconnect 1, 2 and 3 (contract §5). */
    BYPASS_SSE_BACKOFF_MS: [1000, 2000, 5000],
    /** Approval request: poll interval once the stream has failed 3 reconnects in a row (D19). */
    BYPASS_POLL_INTERVAL_MS: 2000,
    /**
     * Approval request: after the countdown reaches 0, how long to wait for the server to report
     * EXPIRED before the dialog gives up on its own (and cancels, so it can never be approved late).
     */
    BYPASS_EXPIRY_GRACE_MS: 10000,
    /** Approval request: how long "อนุมัติแล้ว" stays on screen before the photobooth moves on. */
    BYPASS_APPROVED_SHOW_MS: 2000,
    /**
     * Staff PIN dialog: the reason screen holds a checked PIN, so it goes back to the keypad
     * (forgetting the PIN) after this long without a tap. A walked-away staff member must not
     * leave a one-tap bypass for the next customer.
     */
    STAFF_PIN_REASONS_IDLE_MS: 60000,
    /** Approval request stream: give up on a connection whose response headers have not arrived by then. */
    BYPASS_SSE_HEADERS_TIMEOUT_MS: 15000,
    /** Approval request stream: a connection with no bytes at all for this long is dead (the server pings every 25 s). */
    BYPASS_SSE_IDLE_TIMEOUT_MS: 60000,
    /**
     * Staff PIN lockout: while the countdown is on screen, ask GET /bypass/pin/lockout this often
     * whether the back office has lifted it (D53).
     */
    STAFF_PIN_LOCKOUT_CHECK_MS: 5000,
    /**
     * Staff PIN lockout: a check that has not answered by then is dropped. Shorter than
     * STAFF_PIN_LOCKOUT_CHECK_MS, so a hung check is over before the next one is due and the
     * checks keep their 5 s rhythm instead of skipping every other tick.
     */
    STAFF_PIN_LOCKOUT_CHECK_TIMEOUT_MS: 4000,
    /**
     * Staff PIN lockout: how far behind the server the booth clock may run and its countdown still
     * count as right. The server sets locked_until = its now + 5 min, so a booth clock even 1 s
     * behind sees a little more than 5:00 left; without this slack the "lifted" message never
     * showed on such booths (2.18.1, found in the prod e2e of 05/11/2026).
     */
    STAFF_PIN_LOCKOUT_CLOCK_SLACK_MS: 60000,
}

export const AppAction = {
    APP_NEW_SESSION: 'APP_NEW_SESSION',
}

export const StorageKey = {
    SESSION_ID: 'scr_session_id',
    BRANCH_CODE: 'branch_code',
    BRANCH_ID: 'branch_id',
    POCKET_KEY: 'pocket_key',
    POCKETBASE_AUTH: 'pocketbase_auth',
    POCKET_TOKEN: 'pocket_token',
    PROMO_ID: 'promo_id',
    PROMO_TYPE: 'promo_type',
    PROMO_CODE: 'promo_code',
    PROMO_AMOUNT: 'promo_amount',
    PROMO_USE: 'promo_use',
    DSLRBOOTH_ENDPOINT: 'dslrbooth_endpoint',
    DSLRBOOTH_PASSWORD: 'dslrbooth_password',
    DSLRBOOTH_PORT: 'dslrbooth_port',
    SHOW_MORE_PAYMENT_OPTION: 'show_more_payment_option',
    BRANCH_INTERFACE: 'branch_interface',
    USE_OMEGA_RANDOM: 'use_omega_random',
    USE_OMEGA_RANDOM_READY_CLICK: 'use_omega_random_ready_click',
    USE_FACE_DETECTION: 'use_face_detection',
    IS_FREE_WHITELIST: 'is_free_whitelist',
    IS_PIN_USE: 'is_pin_use',
    PAYMENT_TRX_ID: 'payment_trx_id',
}

export const DslrBoothAction = {
    START: 'start',
}

export const DslrBoothMode = {
    PRINT: 'print',
}

export const PaymentType = {
    FREE: 'FREE',
    PROMPTPAY: 'PROMPTPAY',
    TRUEMONEY: 'TRUEMONEY',
    ALIPAY: 'ALIPAY',
    LINK: 'LINK',
    CREDITCARD: 'CREDITCARD',
}

export const PaymentChannel = {
    FREE: 'FREE',
    OMISE: 'OMISE',
    STRIPE: 'STRIPE',
}

export const PaymentCurrency = {
    THB: 'THB',
    USD: 'USD',
}

export const PaymentDescription = {
    DEFAULT: 'SculptureScreenlock'
}

export const PocketbaseAction = {
    CREATE: 'create',
    UPDATE: 'update',
}

export const OmiseStatusKey = {
    CREATE: 'charge.create',
    COMPLETE: 'charge.complete',
}

export const OmiseStatusName = {
    PENDING: 'pending',
    SUCCESS: 'successful',
}

export const OmiseLinkConfig = {
    TITLE: 'Sculpture Bangkok',
}

export const InterfaceText = {

    GLOBAL_BACK_BUTTON: 'BACK',

    PAYMENT_SCAN_TITLE: 'Please scan Promptpay QR Code',
    PAYMENT_SCAN_SUBTITLE: 'with your mobile banking applications',
    PAYMENT_SCAN_SCULPTURE: 'SCULPTUREBANGKOK',
    PAYMENT_SCAN_CURRENCY: 'THB',
    PAYMENT_SCAN_BACK_BUTTON: 'Back',
    PAYMENT_SCAN_CONFIRM_BUTTON: 'CONFIRM PAYMENT',
    PAYMENT_SCAN_CONFIRM_LOADING: 'Loading...',
    PAYMENT_SCAN_PAYMENT_PROCESSING: '<p>กำลังประมวลผลรายการ...</p><br><p>This transaction is processing...</p>',
    PAYMENT_SCAN_PAYMENT_NOT_FOUND_TITLE: 'Payment Not Found',
    PAYMENT_SCAN_PAYMENT_NOT_FOUND: '<p>ไม่พบรายการชำระเงิน หากท่านได้ชำระเงินเรียบร้อยแล้ว กรุณารอระบบประมวลซักครู่แล้วลองใหม่อีกครั้ง</p><br><p>No payment was found. If you\'ve already made the payment, please wait for a few seconds and try again.</p>',

    PAYMENT_SCAN_PAYMENT_CANCEL_TITLE: 'ยืนยันการออกจากหน้าชำระเงิน',
    PAYMENT_SCAN_PAYMENT_CANCEL: 'SCULPTURE อาจจะใช้เวลาซักครู่ในการประมวลผลการชำระเงิน. <b>หากคุณกดปุ่ม Back หลังจากสแกนจ่ายแล้ว อาจทำให้รายการชำระสูญหาย</b>',
    PAYMENT_SCAN_PAYMENT_CANCEL_STAY: 'อยู่หน้าเดิม',
    PAYMENT_SCAN_PAYMENT_CANCEL_BACK: 'กลับ',

    PAYMENT_SCAN_PAYMENT_CANCEL_TITLE_EN: 'Please confirm exiting this page',
    PAYMENT_SCAN_PAYMENT_CANCEL_EN: 'SCULPTURE might need sometime to process the payment. <b>If you exit this page after finish payment, you might lose your payment!</b>',
    PAYMENT_SCAN_PAYMENT_CANCEL_STAY_EN: 'STAY',
    PAYMENT_SCAN_PAYMENT_CANCEL_BACK_EN: 'EXIT',

    PAYMENT_SCAN_PAYMENT_UNKNOWN_TITLE: 'Unknown Error',
    PAYMENT_SCAN_PAYMENT_UNKNOWN: 'Unknown error occur, Please contact staff for help. (PB)',


    PAYMENT_TRUEMONEY_TITLE: 'PLEASE ENTER YOUR MOBILE NUMBER',
    PAYMENT_TRUEMONEY_SUBTITLE: 'LINKED WITH TRUEMONEY WALLET',
    PAYMENT_TRUEMONEY_TITLE_AFTER: 'PLEASE SCAN QR CODE WITH YOUR MOBILE CAMERA',
    PAYMENT_TRUEMONEY_SUBTITLE_AFTER: 'AND PAY WITH YOUR PHONE',

    PAYMENT_ALIPAY_TITLE: 'PLEASE SCAN QR CODE WITH YOUR MOBILE CAMERA',
    PAYMENT_ALIPAY_SUBTITLE: 'AND PAY WITH YOUR PHONE',


    PAYMENT_LINK_TITLE: 'PLEASE SCAN QR CODE WITH YOUR MOBILE CAMERA',
    PAYMENT_LINK_SUBTITLE: 'AND PAY WITH YOUR PHONE',

    PAYMENT_CREDITCARD_TITLE: 'PLEASE SCAN QR CODE WITH YOUR MOBILE CAMERA',
    PAYMENT_CREDITCARD_SUBTITLE: 'AND PAY WITH YOUR CREDIT CARD',

    PAYMENT_OPTION_PAY: 'PAY',
    PAYMENT_OPTION_PROMOTION_HEADER: 'PROMOTION',
    PAYMENT_OPTION_PROMOTION_FOUND: 'PROMOTION FOUND',

    PAYMENT_OPTION_DIALOG_HEADER: 'STAFF PIN',
    PAYMENT_OPTION_DIALOG_TITLE: 'ENTER YOUR PIN CODE',
    PAYMENT_OPTION_DIALOG_DEL_BUTTON: 'DEL',
    PAYMENT_OPTION_STANDBY_TEXT: 'ENTER YOUR PROMOTION CODE OR QR',
    PAYMENT_OPTION_PROMOTION_BUTTON: 'PROMOTION CODE',
    PAYMENT_OPTION_PROMOTION_BUTTON_QR: 'Promotion QR',
    PAYMENT_OPTION_PROMOTION_BUTTON_TEXT: 'Promotion Code',
    PAYMENT_OPTION_PROMOTION_TYPE_SELECT: 'PROMOTION',
    PAYMENT_OPTION_PROMOTION_TYPE_SELECT_SUBTITLE: 'SELECT PROMOTION TYPE',
    PAYMENT_OPTION_ENTER_YOUR_PROMOTION_CODE: 'ENTER YOUR CODE',


    PAYMENT_PRICE_TITLE: 'PLEASE CONFIRM YOUR ORDER',
    PAYMENT_PRICE_SUBTITLE: 'OR ADD PROMOTION CODE IF YOU HAVE ONE',
    PAYMENT_PRICE_PROMOTION_BUTTON: 'Got Promotion Code?',
    PAYMENT_PRICE_PROMOTION_REMOVE_BUTTON: 'Remove Promotion',
    PAYMENT_PRICE_BACK_BUTTON: 'Back',
    PAYMENT_PRICE_STANDBY_TEXT: 'SCAN YOUR PROMOTION QR',
    PAYMENT_PRICE_PROMOTION_HEADER: 'PROMOTION',
    PAYMENT_PRICE_PROMOTION_FOUND: 'PROMOTION FOUND',

    PAYMENT_PRICE_PRODUCT_NAME: 'PHOTO (PRINT + FILE)',
    PAYMENT_PRICE_LABEL_DISCOUNT: 'DISCOUNT',
    PAYMENT_PRICE_LABEL_VAT: 'VAT',
    PAYMENT_PRICE_LABEL_NET: 'TOTAL',
    PAYMENT_PRICE_LABEL_CURRENCY: 'THB',

    PROMOTION_FOUND: 'PROMOTION FOUND',

    PAYMENT_SCAN_NOT_PAID_TITLE: 'PAYMENT PROCESSING',
    PAYMENT_SCAN_NOT_PAID_TEXT: 'THIS TRANSACTION IS PROCESSING...',
    PAYMENT_SCAN_FAILED_TITLE: 'PAYMENT NOT COMPLETED',
    PAYMENT_SCAN_FAILED_TEXT: 'THIS PAYMENT HAS EXPIRED OR FAILED. PLEASE CHOOSE A PAYMENT METHOD AGAIN.',
    PAYMENT_SCAN_CHECK_ERROR_TITLE: 'CANNOT CHECK PAYMENT',
    PAYMENT_SCAN_CHECK_ERROR_TEXT: 'PLEASE TAP CONFIRM PAYMENT AGAIN.',

    HOME_PIN_HEADER: 'ENTER YOUR PIN CODE',
    HOME_PIN_TITLE: 'EXIT APPLICATION',

    PAY_PIN_HEADER: "STAFF PIN",
    PAY_PIN_TITLE: "ENTER YOUR PIN CODE",

    SKIP_PAYMENT_HEADER: "SKIP PAYMENT"
}

export const InterfaceErrorText = {
    APPLICATION_OFFLINE: 'APPLICATION OFFLINE',
    CONNECTION_ERROR: 'CONNECTION ERROR',
    PROMOTION_NOT_FOUND: 'PROMOTION NOT FOUND',
    PROMOTION_ALREADY_USED: 'PROMOTION ALREADY USED',
    PROMOTION_QUOTA_EXCEED: 'PROMOTION QUOTA EXCEED',
    PROMOTION_REVOKED: 'PROMOTION CANCELED',
    PROMOTION_EXPIRED: 'PROMOTION EXPIRED',
    PROMOTION_EXCEED: 'PROMOTION QUOTA FULL',
    INVALID_PROMOTION_TYPE: 'INVALID PROMOTION TYPE',
    USER_NOT_FOUND: 'USER NOT FOUND',

    PAYMENT_SCAN_QR_ERROR_TITLE: 'QR CODE NOT AVAILABLE',
    PAYMENT_SCAN_QR_ERROR_SUBTITLE: 'Please contact staff for assistance',

    PAYMENT_SUCCESS_DSLR_ERROR_TITLE: 'DSLR ERROR',
    PAYMENT_SUCCESS_DSLR_ERROR_TEXT: 'PLEASE CONTACT STAFF FOR ASSISTANCE',

}

/** Thai copy of StaffPinDialogComponent (D15, D18, D23, D38). */
export const StaffPinText = {
    TITLE_BYPASS: 'ข้ามการชำระเงิน',
    TITLE_CONFIG: 'ตั้งค่า',
    TITLE_EXIT: 'ออกจากโปรแกรม',
    TITLE_LOGOUT: 'เปลี่ยนสาขา',
    ENTER_PIN: 'ใส่ PIN พนักงาน 6 หลัก',
    CHECKING: 'กำลังตรวจสอบ...',
    KEY_CLEAR: 'ล้าง',
    KEY_DELETE: 'ลบ',
    GREETING: 'สวัสดี คุณ',
    CHOOSE_REASON: 'เลือกเหตุผล',
    REASONS_TIMEOUT: 'หมดเวลา กรุณาใส่ PIN อีกครั้ง',
    OVER_LIMIT: 'เกินสิทธิ์วันนี้แล้ว ต้องขออนุมัติ',
    SEND_FOR_APPROVAL: 'ส่งขออนุมัติ',
    WAITING: 'รอผู้อนุมัติ',
    CANCEL: 'ยกเลิก',
    BACK: 'กลับ',
    CLOSE: 'ปิด',
    TRY_AGAIN: 'ลองใหม่',
    APPROVED: 'อนุมัติแล้ว',
    APPROVED_BY: 'โดย ',
    REJECTED: 'ไม่อนุมัติ',
    EXPIRED: 'หมดเวลา',
    CANCELLED: 'คำขอถูกยกเลิก',
    NO_APPROVER: 'สาขานี้ยังไม่มีผู้อนุมัติ',
    OFFLINE: 'ไม่มีการเชื่อมต่อ',
    OFFLINE_DETAIL: 'ข้ามการชำระเงินไม่ได้ขณะออฟไลน์',
    WRONG_PIN: 'PIN ไม่ถูกต้อง',
    NOT_ALLOWED_BRANCH: 'PIN นี้ใช้ที่สาขานี้ไม่ได้',
    ATTEMPTS_LEFT: 'ลองได้อีก',
    LOCKED: 'ใส่ PIN ผิดหลายครั้ง',
    LOCKED_DETAIL: 'ลองใหม่ได้ในอีก',
    /** The back office lifted the lockout (D53). Spelling ล็อก (ก) everywhere. */
    LOCKOUT_LIFTED: 'ปลดล็อกแล้ว กรุณาดำเนินการต่อ',
    INVALID_REASON: 'เหตุผลนี้ใช้ไม่ได้แล้ว กรุณาเลือกใหม่',
    APPROVAL_NOT_NEEDED: 'ไม่ต้องขออนุมัติแล้ว กรุณาเลือกเหตุผลอีกครั้ง',
    REASONS_FAILED: 'โหลดรายการเหตุผลไม่ได้',
    ERROR: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
}

/** Error `code`s of the staff PIN routes (contract §2). Clients branch on these, never on `message`. */
export const StaffPinErrorCode = {
    WRONG_PIN: 'WRONG_PIN',
    NOT_ALLOWED_BRANCH: 'NOT_ALLOWED_BRANCH',
    LOCKED: 'LOCKED',
    INVALID_PIN_FORMAT: 'INVALID_PIN_FORMAT',
    NEEDS_APPROVAL: 'NEEDS_APPROVAL',
    APPROVAL_NOT_NEEDED: 'APPROVAL_NOT_NEEDED',
    INVALID_REASON: 'INVALID_REASON',
    NOT_FOUND: 'NOT_FOUND',
}

/** Every approval request status that never changes again (contract §0). */
export const BYPASS_FINAL_STATUSES = ['APPROVED', 'REJECTED', 'EXPIRED', 'CANCELLED', 'NO_APPROVER'];

/** What StaffPinDialogComponent is showing. */
export enum StaffPinDialogState {
    /** The keypad. */
    PIN = 'PIN',
    /** Greeting, today's count and the reason buttons (payment bypass only). */
    REASONS = 'REASONS',
    /** Approval request sent; countdown and Cancel. */
    PENDING = 'PENDING',
    /** The approver said yes: shown for AppConfig.BYPASS_APPROVED_SHOW_MS, then SUCCESS. */
    APPROVED = 'APPROVED',
    /** Bypass granted or staff-menu entry recorded; the host navigates. */
    SUCCESS = 'SUCCESS',
    REJECTED = 'REJECTED',
    EXPIRED = 'EXPIRED',
    CANCELLED = 'CANCELLED',
    NO_APPROVER = 'NO_APPROVER',
    LOCKED = 'LOCKED',
    OFFLINE = 'OFFLINE',
    ERROR = 'ERROR',
}

export const PromotionType = {
    FREE: 'FREE',
    AMOUNT: 'AMOUNT',
    PERCENT: 'PERCENT',
    NONE: 'NONE'
}

export const PromotioCodeType = {
    STATIC: 'STATIC',
    DYNAMIC: 'DYNAMIC',
}

export enum HiddenMenuMode {
    NONE = 'NONE',
    CONFIG = 'CONFIG',
    EXIT = 'EXIT',
    LOGOUT = 'LOGOUT',
}

export const GlobalConfigKey = {
    FREE_WHITELIST_BRANCH: 'free_whitelist_branch',
    SCULPTURE_MONITOR_EMAILS: 'sculpture_monitor_emails',
    FLAG_USE_BRANCH_TIME: 'flag_use_branch_time',
    FLAG_USE_SNOW: 'flag_use_snow',
    SCULPTURE_BRANCH_HIDE_PAY: 'sculpture_branch_hide_pay',
    SCULPTURE_BRANCH_SKIP_TERMS: 'sculpture_branch_skip_terms',
    USE_OMEGA_RANDOM: 'use_omega_random',
    USE_FACE_DETECTION: 'use_face_detection',
    USE_POINT_COLLECTION: 'use_point_collection',
    SKIP_POINT_COLLECTION: 'skip_point_collection',
    SCULPTURE_HIDE_PROMO_BUTTON: 'sculpture_hide_promo_button',
    BRANCH_THEME_MAP: 'branch_theme_map',
    SKIP_PAYMENT_SUCCESS_PAGE: 'skip_payment_success_page'
}

export const AppTheme = {
    DEFAULT: 'default',
    THE_PORTRAIT: 'the_portrait'
}

export enum PinDialogEvent {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    CLOSE_DIALOG = 'CLOSE_DIALOG',
}

export enum PointCollectDialogEvent {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    CLOSE_DIALOG = 'CLOSE_DIALOG',
}
/** What StaffPinDialogComponent reports to its host. `mode` NONE = payment bypass. */
export interface PinDialogVerifyResult {
    mode: HiddenMenuMode
    event: PinDialogEvent,
    /** The PIN use the API recorded, on SUCCESS. */
    pin_use_id?: number | null,
}

export interface PointCollectDialogResult {
    event: PointCollectDialogEvent,
}

/** Why the /home banner popup went away; reported to the API as close_reason. */
export enum BannerCloseReason {
    BUTTON = 'button',
    BACKDROP = 'backdrop',
    NAVIGATED = 'navigated',
    OFFLINE = 'offline',
}

export enum BannerPopupEvent {
    CLOSE = 'CLOSE',
}

export interface BannerPopupResult {
    event: BannerPopupEvent,
    reason: BannerCloseReason,
}

export type BannerOrientation = 'landscape' | 'portrait';

export enum PointCollectStage {
    PROVIDE_MOBILE_NO = 'provide_mobile_no',
    PROVIDE_INFO = 'provide_info',
    SHOW_POINTS = 'show_points',
    COMPLETED = 'completed',
}

export const MonthList = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' },
]

export const GenderList = [
    { id: 'M', name: 'Male' },
    { id: 'F', name: 'Female' },
    { id: 'X', name: 'Prefer not to say' },
];

export enum SourceSystem {
    SCREENLOCK_V2 = 'SCREENLOCK_V2',
    SCULPTURE_V3 = 'SCULPTURE_V3',
    SCULPTURE_HYBRID = 'SCULPTURE_HYBRID',
    GACHAPON = 'GACHAPON',
    SNAP = 'SNAP',
}

export enum RedeemType {
    FREE_TICKET = 'FREE_TICKET',
}